/**
 * 封装一些 chrome.usb 的 API，改为 Promise 接口
 */

const getDevices = (): Promise<any[]> => {
    if (window.chrome && window.chrome.usb) {
        return new Promise((resolve, reject) => {
            window.chrome.usb.getDevices({}, function(deviceList: any[]) {
                if (window.chrome.runtime && window.chrome.runtime.lastError) {
                    reject(window.chrome.runtime.lastError);
                }
                resolve(deviceList);
            });
        });
    } else {
        return Promise.resolve([]);
    }
};

const openDevice = (device: any): Promise<any> => {
    if (window.chrome && window.chrome.usb) {
        return new Promise((resolve, reject) => {
            window.chrome.usb.openDevice(device, function(connectionHandle: any) {
                if (window.chrome.runtime && window.chrome.runtime.lastError) {
                    reject(window.chrome.runtime.lastError);
                }
                resolve(connectionHandle);
            });
        });
    } else {
        return Promise.reject(new Error('API 不支持'));
    }
};

const checkLastError = (resolve: Function, reject: Function) => {
    if (window.chrome.runtime && window.chrome.runtime.lastError) {
        reject(window.chrome.runtime.lastError);
    }
    resolve();
};

const claimInterface = (connectionHandle: any, interfaceNumber: number): Promise<void> => {
    if (window.chrome && window.chrome.usb) {
        return new Promise((resolve, reject) => {
            window.chrome.usb.claimInterface(connectionHandle, interfaceNumber, function() {
                checkLastError(resolve, reject);
            });
        });
    } else {
        return Promise.reject(new Error('API 不支持'));
    }
};

const bulkTransfer = (connectionHandle: any, options: any): Promise<void> => {
    if (window.chrome && window.chrome.usb) {
        return new Promise((resolve, reject) => {
            window.chrome.usb.bulkTransfer(connectionHandle, options, function() {
                checkLastError(resolve, reject);
            });
        });
    } else {
        return Promise.reject(new Error('API 不支持'));
    }
};

const closeDevice = (connectionHandle: any): Promise<void> => {
    if (window.chrome && window.chrome.usb) {
        return new Promise((resolve, reject) => {
            window.chrome.usb.closeDevice(connectionHandle, function() {
                checkLastError(resolve, reject);
            });
        });
    } else {
        return Promise.reject(new Error('API 不支持'));
    }
};

export { getDevices, openDevice, claimInterface, bulkTransfer, closeDevice };
